import React, { Component } from 'react';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';

import { Loading, ErrorMessage } from '../shared/layout';
import { withAuth } from '../shared/auth';
import { withFirebase } from '../shared/firebase';
import { PollInfo } from '../poll';
import { upgradeMdl } from '../utils';

class PanelBase extends Component {

  static cardStyle = {
    width: 'initial',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  }

  static panelInfoStyle = {
    width: 'initial',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative'
  }

  static toggleContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    right: 0,
    top: 0,
    margin: '8px',
  }

  state = {
    polls: null,
    loading: true,
    error: null,
    showMainnet: true,
    showTestnet: true
  }

  toggleShowMainnet = () => this.setState({ showMainnet: !this.state.showMainnet });
  toggleShowTestnet = () => this.setState({ showTestnet: !this.state.showTestnet });

  componentWillMount() {
    this.props.firebase.getUserPolls(this.props.auth.userId)
      .then(data => data.sort((a, b) => ('' + a.name).localeCompare(b.name)))
      .then(polls => this.setState({ polls, loading: false }))
      .catch((err) => {
        console.error(err);
        this.setState({
          error: 'GENERIC_ERROR',
          loading: false
        });
      });
  }

  componentDidUpdate() {
    upgradeMdl();
  }

  render() {
    const { loading, polls, error, showMainnet, showTestnet } = this.state;

    return loading ? <div className="loading-page-content"><Loading /></div> :
      error ? <div className="error-page-content"><ErrorMessage message={error} /></div> : (
      <div className="mdl-grid">
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop" style={{minHeight: '100px'}}>
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={PanelBase.panelInfoStyle}>
            <h6 style={{ marginBottom: 24 }}>Below you can see your polls.</h6>
            <p>Please remember that you need to publish the poll to receive tokens and let others to vote. You can edit polls before publishing as many tmes as you want but remember that published polls cannot be edited anymore. On each published poll you will see an information on which net (MainNet / TestNet) was it published.</p>
            <div className="toggle-container" style={PanelBase.toggleContainerStyle}>
              <p style={{ fontSize: 14, margin: 0, textAlign: 'left' }}>Filter polls:</p>
              <label className="mdl-switch mdl-js-switch mdl-js-ripple-effect token-switch" htmlFor="show-mainnet" style={{width: '140px'}}>
                <input
                  type="checkbox"
                  id="show-mainnet"
                  className="mdl-switch__input"
                  onChange={this.toggleShowMainnet}
                  checked={showMainnet}
                ></input>
                <span className="mdl-switch__label" style={{ fontSize: 14 }}>Mainnet</span>
              </label>
              <label className="mdl-switch mdl-js-switch mdl-js-ripple-effect token-switch" htmlFor="show-testnet" style={{width: '140px'}}>
                <input
                  type="checkbox"
                  id="show-testnet"
                  className="mdl-switch__input"
                  onChange={this.toggleShowTestnet}
                  checked={showTestnet}
                ></input>
                <span className="mdl-switch__label" style={{ fontSize: 14 }}>Testnet</span>
              </label>
            </div>
          </div>
        </div>
        {polls.filter(it => !it.net || (it.net === 'MAIN' && showMainnet) || (it.net === 'TEST' && showTestnet)).map(poll => <PollInfo poll={poll} key={poll.id}/>)}
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--6-col mdl-cell--12-col-tablet mdl-cell--6-col-desktop">
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={PanelBase.cardStyle}>
            <Link to="/create">
              <button className="mdl-button mdl-js-button mdl-button--fab mdl-button--colored">
                <i className="material-icons">add</i>
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
};

export const Panel = compose(withFirebase, withAuth)(PanelBase);
